const routes = [{
  path: '/role/setting',
  component: () => import('@/views/role/setting'),
  name: 'role-setting',
  meta: {
    title: '角色管理'
  }
}, {
  path: '/role/home',
  component: () => import('@/views/role/home'),
  name: 'role-home',
  meta: {
    title: '角色管理'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/human/role.js